import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Tabs } from "@volca/ui/components/ui/tabs";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReferralHistorySidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      gap={4}
      direction="column"
      justify="between"
      align="start"
      className={"flex-none p-6"}
    >
      <Skeleton className="h-[30px] w-3/5"></Skeleton>
      <Stack align="start" className="flex flex-col gap-2" gap={4}>
        <Skeleton className="h-7 w-60"></Skeleton>
        <Skeleton className="h-5 w-40"></Skeleton>
      </Stack>
      <Skeleton className="mt-2 h-10 w-full"></Skeleton>
    </Stack>
    <div className="flex-1 overflow-hidden">
      <Stack align="start" gap={0} className="h-full w-full">
        <Tabs className="flex w-full flex-1 flex-col gap-4 overflow-hidden px-6">
          <Stack
            align="start"
            direction="row"
            justify="between"
            gap={4}
            className="border-b py-5.5"
          >
            <Skeleton className="h-5 w-full"></Skeleton>
            <Skeleton className="h-5 w-full"></Skeleton>
          </Stack>

          <Stack align="start" gap={6} className="mt-2 w-full">
            <Skeleton className="h-[58px] w-full"></Skeleton>
            <Skeleton className="h-[58px] w-full"></Skeleton>
            <Skeleton className="h-[58px] w-full"></Skeleton>
            <Stack className="w-full" align="start" gap={2}>
              <Skeleton className="h-4 w-20"></Skeleton>
              <Skeleton className="h-[102px] w-full"></Skeleton>
            </Stack>

            <Stack align="start" direction="row" gap={4}>
              <Skeleton className="h-10 w-39"></Skeleton>
              <Skeleton className="h-10 w-26"></Skeleton>
            </Stack>

            <Stack className="w-full" align="start" gap={2}>
              <Skeleton className="h-4 w-25"></Skeleton>
              <Skeleton className="h-5 w-20"></Skeleton>
            </Stack>

            <Stack className="w-full" align="start" gap={2}>
              <Skeleton className="h-4 w-20"></Skeleton>
              <Skeleton className="h-5 w-65"></Skeleton>
            </Stack>

            <Stack className="w-full" align="start" gap={2}>
              <Skeleton className="h-4 w-20"></Skeleton>
              <Skeleton className="h-5 w-full"></Skeleton>
              <Skeleton className="h-3 w-full"></Skeleton>
            </Stack>
          </Stack>

          <Skeleton className="mt-2 h-11 w-full"></Skeleton>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
